import { showEvents } from "@/Configs/config";
import { useConfig } from "@/api/hooks/useConfig";
import { useAccessPoints } from "@/pages/infrastructure/manage/useAccessPoints";

import { FC } from "react";

import { ContainerDrawerProps } from "./containerDrawer";
import { ContainerAdmin } from "./drawerCards/ContainerAdmin";
import { ContainerBulkMove } from "./drawerCards/ContainerBulkMove";
import { ContainerFillLevel } from "./drawerCards/ContainerFillLevel";
import { ContainerHatches } from "./drawerCards/ContainerHatches";
import { ContainerInformation } from "./drawerCards/ContainerInformation";
import { ContainerSmartCapabilities } from "./drawerCards/ContainerSmartCapabilities";
import { PointChangeHistory } from "./drawerCards/PointChangeHistory";
import { PreFilteringCard } from "./drawerCards/PreFilteringCard";

export const SingleContainerDrawer: FC<ContainerDrawerProps> = ({
  accessParentId,
  containerId,
  depotId,
}) => {
  const { isMWM } = useConfig();

  const { getContainer } = useAccessPoints({ accessParentId });
  const container = getContainer(containerId, depotId);

  return (
    <>
      <ContainerInformation {...{ accessParentId, containerId, depotId }} />
      {isMWM && container?.fillLevel && (
        <ContainerFillLevel fillLevel={container?.fillLevel} />
      )}
      <ContainerHatches {...{ accessParentId, containerId, depotId }} />
      <ContainerSmartCapabilities
        {...{ accessParentId, containerId, depotId }}
      />
      {!isMWM && <ContainerBulkMove />}
      {isMWM && (
        <>
          {showEvents && (
            <PreFilteringCard
              entityKey="container"
              eventFilter={encodeURIComponent(JSON.stringify({ containerId }))}
            />
          )}
          <PointChangeHistory
            id={containerId}
            name={container?.name || ""}
            entityKey="container"
          />
        </>
      )}
      <ContainerAdmin {...{ accessParentId, containerId, depotId }} />
    </>
  );
};
